// @flow
import { getCreator, deleteCreator } from '../../http';
import environment from '../../environment';

import type { Flight } from '../../entities';

export type GetActiveFlights = {
  flights: Flight[];
  total: number;
};

export type GetPastFlights = {
  flights: Flight[];
  total: number;
};

export const endpoints = Object.freeze({
  // can be extended for pagination
  GET_ACTIVE_FLIGHTS: `${environment.apiUrl}/flight/current`,
  GET_PAST_FLIGHTS: `${environment.apiUrl}/flight/past`,
  DELETE_FLIGHT: `${environment.apiUrl}/flight/:id`,
});

export const getPastFlightsApi = getCreator(fetch, endpoints.GET_PAST_FLIGHTS);
export const deleteFlightApi = deleteCreator(fetch, endpoints.DELETE_FLIGHT);
export const getActiveFlightsApi = getCreator(fetch, endpoints.GET_ACTIVE_FLIGHTS);



// WEBPACK FOOTER //
// ./src/modules/flights/api.js